import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-79a5dcf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExportDropdown = _resolveComponent("ExportDropdown")!
  const _component_SearchFilterBar = _resolveComponent("SearchFilterBar")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_IPColumn = _resolveComponent("IPColumn")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_LoadMoreButton = _resolveComponent("LoadMoreButton")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _component_RawDataDrawer = _resolveComponent("RawDataDrawer")!
  const _directive_date_format = _resolveDirective("date-format")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentAdaptLayout, {
      class: "cm-ui-shadow-container",
      style: {"padding":"16px 16px 16px"}
    }, {
      header: _withCtx(() => [
        _createVNode(_component_SearchFilterBar, {
          style: {"padding":"0","background-color":"transparent"},
          modelValue: _ctx.queryParams,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryParams) = $event)),
          "form-columns": _ctx.filterFormColumns,
          "show-search": true,
          "search-placeholder": _ctx.$t('noticeManage.searchPlaceholderComputerIp'),
          "popover-threshold": 2,
          onSearch: _ctx.handleSearch,
          onQuery: _ctx.handleQuery,
          onReset: _ctx.handleReset
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_ExportDropdown, {
              "button-text-i18n-key": "noticeManage.exportRecord",
              onExport: _ctx.download
            }, null, 8, ["onExport"])
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "search-placeholder", "onSearch", "onQuery", "onReset"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_LoadMoreButton, {
          loading: _ctx.isLoading,
          current: _ctx.data.list.length,
          total: _ctx.data.total,
          onLoadMore: _ctx.loadMoreData
        }, null, 8, ["loading", "current", "total", "onLoadMore"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "empty-text": _ctx.$t('common.noData'),
          data: _ctx.data.list,
          width: "100%",
          height: "100%",
          "default-sort": _ctx.defaultSort,
          onSortChange: _ctx.handlerSort
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              "class-name": "cm-ui-pl20",
              prop: "create_time",
              label: _ctx.$t('noticeManage.time'),
              "min-width": "180",
              sortable: "custom"
            }, {
              default: _withCtx((scope) => [
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_directive_date_format, {value: scope.row.create_time * 1000, format: 'YYYY-MM-DD HH:mm'}]
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              "min-width": "200",
              prop: "computer_name",
              label: _ctx.$t('listColumns.computerName')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              "min-width": "150",
              prop: "user_mark",
              label: _ctx.$t('listColumns.userMark')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              "min-width": "150",
              prop: "group_name",
              label: _ctx.$t('listColumns.groupName')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              "min-width": "160",
              label: _ctx.$t('noticeManage.ipAddress')
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_IPColumn, {
                  cip: scope.row.client_ip,
                  sip: scope.row.system_ip
                }, null, 8, ["cip", "sip"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "mac",
              label: _ctx.$t('noticeManage.macAddress'),
              "min-width": "180"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              prop: "item_type",
              label: _ctx.$t('noticeManage.changeItem')
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_ctx.changeTypeLabels[scope.row.item_type]), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              "min-width": "200",
              prop: "origin_setting",
              label: _ctx.$t('noticeManage.originSetting')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              "min-width": "200",
              prop: "new_setting",
              label: _ctx.$t('noticeManage.newSetting')
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('noticeManage.operation'),
              width: "100",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: "cm-link-light underline",
                  onClick: ($event: any) => (_ctx.showRawData(scope.row))
                }, _toDisplayString(_ctx.$t('noticeManage.rawData')), 9, _hoisted_1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["empty-text", "data", "default-sort", "onSortChange"])), [
          [_directive_loading, _ctx.isLoading],
          [_directive_load_more, _ctx.loadMoreData]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_RawDataDrawer, {
      modelValue: _ctx.data.isShowRawData,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.isShowRawData) = $event)),
      "raw-data": _ctx.data.currentRow
    }, null, 8, ["modelValue", "raw-data"])
  ], 64))
}